import { IBlogPageViewModel } from 'Types/Litium';
import MagnicifactionGlassIcon from 'Icons/magnificationGlass.svg?react';

interface BlogRightNavigationProps {
    filterTagListHeaderText: IBlogPageViewModel['filterTagListHeaderText'];
    searchLinkBase: IBlogPageViewModel['searchLinkBase'];
    blogSearchPlaceholderText: IBlogPageViewModel['blogSearchPlaceholderText'];
    filterTagList: IBlogPageViewModel['filterTagList'];
}

const BlogLeftNavigation = ({
    filterTagListHeaderText,
    searchLinkBase,
    blogSearchPlaceholderText,
    filterTagList,
}: BlogRightNavigationProps) => (
    <ul className="mr-4 hidden min-w-[12.5%] lg:block">
        <li className="flex">
            <form
                className="relative flex h-10 w-full items-center gap-2 border-b-[1px] border-black text-xs"
                method="get"
                action={searchLinkBase}
            >
                <label
                    className="absolute -left-[3px]"
                    htmlFor="quicksearch"
                    id="quicksearchLabel"
                >
                    <MagnicifactionGlassIcon
                        title={blogSearchPlaceholderText}
                        className="h-8 w-8"
                    />
                    <span className="sr-only">{blogSearchPlaceholderText}</span>
                </label>
                <input
                    id="query"
                    type="text"
                    name="query"
                    aria-labelledby="quicksearchLabel"
                    className="h-full w-full bg-transparent indent-9 font-roboto text-sm font-normal text-black placeholder:font-roboto placeholder:font-normal placeholder:text-black"
                    placeholder={blogSearchPlaceholderText}
                />
            </form>
        </li>

        <li className="mt-8">
            <span className="font-montserrat text-base font-medium uppercase">
                {filterTagListHeaderText}
            </span>
        </li>

        {filterTagList.length > 0 && (
            <li className="mb-5 mt-3">
                <ul>
                    {filterTagList.map((item, index) => (
                        <li className="mb-6" key={index}>
                            <a
                                className="text-ellipsis font-montserrat text-base font-medium leading-5"
                                href={item.url}
                            >
                                <img
                                    src={item.image.src}
                                    alt={item.image.altText}
                                    width={
                                        item.image.width > 0
                                            ? item.image.width
                                            : ''
                                    }
                                    height={
                                        item.image.height > 0
                                            ? item.image.height
                                            : ''
                                    }
                                />
                                {item.name}
                            </a>
                        </li>
                    ))}
                </ul>
            </li>
        )}
    </ul>
);

export default BlogLeftNavigation;
